import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private titleService = inject(Title);

  private siteTitle = 'Careers at Graphisoft';

  setTitle(newTitle: string) {
    let title = this.siteTitle;
    if (newTitle) {
      title = newTitle + ' - ' + title;
    }
    this.titleService.setTitle(title);
  }
}
